export default __webpack_public_path__ + "static/media/upload.4f7e2c28.svg";